export default {
	TRANSCRIPT: 1,
	VIDEO_QUESTIONS: 2,
}
